<template>
    <flex-element :element-type="elementType" class="f-flex">
        <nav-dropdown
            v-for="(element, index) in elementsNew"
            :key="element.id"
            v-bind="element"
            :index="index"
            :pointer="index + 1"
            @element-updated="elementUpdated"
        />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-dumb';

export default {
    name: 'nav-dropdown-collection',
    mixins: [baseOrganism],
};
</script>
